import useEstimateRenewal from "features/subscriptions/datahooks/useEstimateRenewal";

import type { PricingPeriodInfo } from "common/types";

import Price from "../Price";

interface WorkspaceSubRenewalPriceProps {
  pricingPeriodInfo?: PricingPeriodInfo;
  subscriptionId?: string;
  isScheduledCancellation?: boolean;
}

export default function WorkspaceSubRenewalPrice({
  subscriptionId,
  pricingPeriodInfo,
  isScheduledCancellation,
}: WorkspaceSubRenewalPriceProps) {
  const { estimateRenewal, isLoadingEstimateRenewal } =
    useEstimateRenewal(subscriptionId);

  return (
    <Price
      estimate={estimateRenewal}
      pricingPeriodInfo={pricingPeriodInfo}
      isScheduledCancellation={isScheduledCancellation}
      isLoading={
        !subscriptionId || !pricingPeriodInfo || isLoadingEstimateRenewal
      }
    />
  );
}
